import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { shouldDisplayTourStylesGroupBenefit } from 'constants/tours'
import config from 'constants/config'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { rem } from 'polished'
import type { ComponentProps } from 'react'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import TourStyledNonSignatureProductTypeInfoSheet from './TourStyledNonSignatureProductTypeInfoSheet'

type NonSignatureStyledProductType = Exclude<App.Tours.V2ProductTypeStyled, App.Tours.V2SignatureSeriesProductType | App.Tours.V2InsiderSeriesProductType>

const NON_SIGNATURE_STYLES: Array<NonSignatureStyledProductType> = ['deluxe_tour', 'premium_tour', 'ultra_lux_tour']

const StylesContainer = styled.div`
  display: grid;
  grid-template: repeat(3, 1fr) / 1fr;
  padding-block: ${rem(12)};

  ${mediaQueryUp.tablet} {
    grid-template: 1fr / repeat(3, 1fr);
  }
`

type InheritedModalProps = Pick<ComponentProps<typeof Modal>, 'primaryActionText' | 'primaryActionTo'>

interface Props extends InheritedModalProps {
  productType: NonSignatureStyledProductType
  offerId?: string
}

export type TourStyledNonSignatureProductTypeInfoModalResult = 'primary-action' | undefined

function TourStyledNonSignatureProductTypeInfoModal({
  productType,
  offerId,
  primaryActionText,
  primaryActionTo,
}: Props) {
  const modalElement = useModalElementContext<TourStyledNonSignatureProductTypeInfoModalResult>()
  const intl = useIntl()

  const handlePrimaryClick = useCallback(() => {
    modalElement.resolve('primary-action')
  }, [modalElement])

  const title = intl.formatMessage(
    {
      id: 'Ro_v6tXKltWR2iMPNzVY',
      defaultMessage: '{brandName} Tour Styles',
    },
    { brandName: config.brandConfig.name },
  )

  const footnoteText = intl.formatMessage(
    {
      id: 'aABJC1C7JwGrDKj6-Uwp',
      defaultMessage: '*Max travellers do not apply for Private Tours.',
    },
  )

  const showGroupBenefit = !offerId || shouldDisplayTourStylesGroupBenefit(offerId)

  return <Modal
    size="L"
    title={title}
    primaryActionText={primaryActionText}
    primaryActionTo={primaryActionTo}
    onPrimaryActionClick={!primaryActionTo ? handlePrimaryClick : undefined}
    // secondaryActionText="Learn more"
  >
    <Group direction="vertical" gap={8}>
      <StylesContainer>
        {NON_SIGNATURE_STYLES.map((knownTourStyle) => <TourStyledNonSignatureProductTypeInfoSheet
          key={knownTourStyle}
          productType={knownTourStyle}
          isCurrent={knownTourStyle === productType}
          showGroupBenefit={showGroupBenefit}
        />)}
      </StylesContainer>
      {showGroupBenefit && <BodyText colour="light-foreground-alt" variant="medium">
        {footnoteText}
      </BodyText>}
    </Group>
  </Modal>
}

export default TourStyledNonSignatureProductTypeInfoModal
